<template>
  <v-container fluid>
    <v-row>
      <v-col class="pt-0">
        <orders />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from "date-fns";
import Orders from '@/components/reports/Orders'
// import generateId from "@/idGenerator";
// import { getApi } from "@/api";

export default {
  data() {
    return {
      tab: null,
      fetching: true
    };
  },
  computed: {
    
  },
  methods: {
    format,
    fetch() {

    }
  },
  mounted() {
    this.fetch();
  },
  watch: {},
  components: {
    Orders
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
